import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';

@Component({
  selector: 'app-add-delete-shift-plan',
  templateUrl: './add-delete-shift-plan.component.html',
  styleUrls: ['./add-delete-shift-plan.component.scss']
})
export class AddDeleteShiftPlanComponent implements OnInit {

  endsOnTableList = AppSettings.SHIFT_PLANNING_ENDSON_TABLELIST;
  endsOnFilterTableList = AppSettings.SHIFT_PLANNING_ENDSON_FILTERLIST;
  // @Input() selectedAddDataEmmiter: any;

  labelAddShift: any;
  shiftAllData: any = [];
  labelYes: any;
  labelNo: any;
  minDate: Date;
  maxDate: Date;
  dateFormat;
  teamList: any[] = [];
  formRequiredStatus = false;
  daysList = AppSettings.SHIFT_PLANNING_DAYS_LIST;
  shiftButtonDisabled = false;
  allocationListStr = '';
  shiftStartTime: any;
  shiftEndTime: any;
  teamListIds: any = [];
  startDateTimeStr: any;
  endDateTimeStr: any;
  groupLimit = 100;
  groupOffset = 0;
  totalRecords: any;
  products: any = [];
  minuteArray: number[] = [0, 15, 30, 45];
  currentDate = new Date();
  isEditEnable = false;
  loginTypeList: any;
  loginTypeisWeb = false;
  urlAssign = '';
  gridTheme = 'mi';
  url = '';
  newUrl;
  gridColumn: any[] = [];
  exportUrl = '';
  printUrl = '';
  searchDisplay = true;
  columns: any = [];
  // @ViewChild(MiGridSelectionComponent) gridRef: MiGridSelectionComponent;
  totalAndActiveCounts: { label: any; value: any; }[];
  buttons: any[] = [];
  params: any = '';
  selectedData: any;
  weeklyAllocationData: string;
  teamNames: string;
  teamName: any;
  endTimeStr: any;
  startTimeStr: any;
  endDateTime: string;
  selectedScheduleId: string;
  teamChecked: any[] = [];
  userType: any;
  selectedProviderId: string;
  startDateTimes: string;
  allTeamChecked: any[] = [];
  bulckScheduleId: any[];
  bulckScheduleChecked = false;
  endDateTimeS: any;
  endDateTimeSe: any;
  teamNamesa: string;
  isChecked = true;
  maxDays = '10';
  shiftPlanUsers: any;
  showDialog = false;
  showWithoutPtoDialog = false;
  showWithPtoDialog = false;
  labelOverride = 'Override';
  labelAdjust = 'Adjust';
  labelCancel = 'Cancel';
  labelSave = 'Save';
  /*labelYes = 'Yes';
  labelNo = 'No';*/
  selectedRowdata: any;
  updateType: any;
  startEndTimeValidationStatus = true;
  userId: any;
  providerId: any;
  firstName: any;
  lastName: any;
  selectedTeamList: any;
  isDeleteCheckboxSelected = false;
  ptoCheckbox = false;
  organizationLevelShift;
  isPTOEnable;
  assignedTeamId: any;
  constructor(
    private commonBindingDataService: CommonBindingDataService,
    private manageOpenShiftsService: ManageOpenShiftsService,
    private router: Router,
    private uiService: UiService,
    private storageService: StorageService,
    private commonService: CommonBindingDataService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.isPTOEnable = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.PTO)?.value;
    this.organizationLevelShift = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.ORGANIZATION_LVL_2)?.value;
    this.route.queryParams.subscribe(params => {
      this.userId = params['userId'];
      this.providerId = params['providerId'];
      this.firstName = params['f'];
      this.lastName = params['l'];
      this.userType = params['userType'];
      this.assignedTeamId = params['teamId'];
    });
    this.getLabelAndDate();
    this.getShiftData();
    this.getTeam();
    this.currentDate = this.commonBindingDataService.addOneHourToCurrentTime();
  }



  goBack() {
    // this.location.back(); // <-- go back to previous location
    this.router.navigate(['manage-shift/team-members/week']);
  }

  checkboxClicked(event) {
    this.teamChecked = event;
    if (this.teamChecked.length > 0) {
      this.bulckScheduleChecked = true;
    } else {
      this.bulckScheduleChecked = false;

    }
  }

  allTasksEvent(event) {
    this.allTeamChecked = event;
  }

  selectAllData(event) {
    if (event === true) {
      this.teamChecked = this.allTeamChecked;
      if (this.teamChecked) {
        this.bulckScheduleChecked = true;
      }
    } else {
      this.bulckScheduleChecked = false;

    }
  }

  colFullName(params) {
    let lblActivate = '';
    let lastName = '';
    let permanentSchedule;
    if (params.lastName !== null && params.lastName !== 'null') {
      lastName = params.lastName;
    }
    permanentSchedule = params.permanentSchedule ? '*' : '';
    if (params.firstName) {
      if (params.numCountryCode !== undefined && params.numCountryCode !== null) {
        lblActivate = `<div title="` + permanentSchedule + params.firstName + ' ' + lastName + `">` + permanentSchedule + params.firstName + ' ' + lastName + '';
      } else {
        lblActivate = `<div title="` + permanentSchedule + params.firstName + ' ' + lastName + `">` + permanentSchedule + params.firstName + ' ' + lastName + '';
      }
    }
    const eDiv = document.createElement('div');
    eDiv.setAttribute('class', 'grid-comman-col');
    eDiv.innerHTML = lblActivate;
    return eDiv;
  }

  setEmail(params) {
    let email = '';
    if (params) {
      email = `<div title="` + params + `">` + params +
        `</div>`;
    } else {
      email = `<div title=""> -- </div>`;
    }

    const eDiv = document.createElement('div');
    eDiv.innerHTML += email;
    return eDiv;
  }

  getDate(params) {
    const tripTime = params.appliedOnStr;
    const date = this.commonBindingDataService.toTimezoneDateTimeStringFormatStr(params.appliedOnStr, params.timezoneAbbr);
    const time = this.commonBindingDataService.toTimezoneTimeFormatWithout(params.appliedOnStr, params.timezoneAbbr);

    let tripDateTime = '';
    if (tripTime !== null && tripTime !== 0) {
      tripDateTime = `<div title="` + date + `">` + date + `</div><div title="` + time + `">` + `</div>`;
    } else {
      tripDateTime = `<div title="">--</div>`;
    }
    const eDiv = document.createElement('div');
    eDiv.innerHTML += tripDateTime;
    return eDiv;
  }

  getLabelAndDate() {
   this.labelYes = this.commonBindingDataService.getLabel('label_yes');
    this.labelNo = this.commonBindingDataService.getLabel('label_no_without_dot');
    this.labelAddShift = this.commonBindingDataService.getLabel('label_add_new_shift');
    this.dateFormat = this.commonBindingDataService.getDateFormat();
    this.minDate = new Date();
    this.maxDate = new Date();
  }

  getShiftData() {
    this.manageOpenShiftsService.getShiftPlanningData(this.groupLimit, this.groupOffset).subscribe(results => {
      this.totalRecords = results.count;
      // this.shiftAllData = [...this.shiftAllData, ...results.data];
      this.groupLimit = results.count;
      this.shiftAllData = results.data;
      this.products = results.data;
      for (let i = 0; i < this.shiftAllData.length; i++) {
        const text = this.shiftAllData[i].allocations;
        Object.assign(this.shiftAllData[i], {
          'weeklyAllocation': [
            { key: '1', displayValue: 'S', isMandatory: text.includes('1') },
            { key: '2', displayValue: 'M', isMandatory: text.includes('2') },
            { key: '3', displayValue: 'T', isMandatory: text.includes('3') },
            { key: '4', displayValue: 'W', isMandatory: text.includes('4') },
            { key: '5', displayValue: 'T', isMandatory: text.includes('5') },
            { key: '6', displayValue: 'F', isMandatory: text.includes('6') },
            { key: '7', displayValue: 'S', isMandatory: text.includes('7') }
          ]
        }, );
        const teamListAllId = [];
        for (let j = 0; j < this.shiftAllData[i].teamList.length; j++) {
          teamListAllId.push(this.shiftAllData[i].teamList[j].teamId);
        }
        // const teamListAllId = this.shiftAllData[i].teamList[0].teamId;
        Object.assign(this.shiftAllData[i], { 'selectedTeamList': teamListAllId });
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  newRow() {
    return {
      weeklyAllocation: [
        { key: '1', displayValue: 'S', isMandatory: false },
        { key: '2', displayValue: 'M', isMandatory: false },
        { key: '3', displayValue: 'T', isMandatory: false },
        { key: '4', displayValue: 'W', isMandatory: false },
        { key: '5', displayValue: 'T', isMandatory: false },
        { key: '6', displayValue: 'F', isMandatory: false },
        { key: '7', displayValue: 'S', isMandatory: false }
      ],
      spPermenantMembers: [], shiftSchedule: '', startTimeStr: '', endTimeStr: '', endDate: '', teamList: ''
    };
  }

  validateForm() {
   this.shiftStartTime = this.shiftStartTime ? this.shiftStartTime
     : (this.startTimeStr.toString().includes('M') ? this.startTimeStr
       : moment(new Date(this.startTimeStr)).format('hh:mm A'));
   this.shiftEndTime = this.shiftEndTime ? this.shiftEndTime
     : (this.endTimeStr.toString().includes('M') ? this.endTimeStr
       : moment(new Date(this.endTimeStr)).format('hh:mm A'));
    const d = new Date();
    const dateValue = moment(d).format('MM/DD/YYYY');
    const startValue = new Date(dateValue + ' ' + this.shiftStartTime);
    const endValue = new Date(dateValue + ' ' + this.shiftEndTime);
    const startTimeMillis = startValue.getTime();
    const endTimeMillis = endValue.getTime();
    if (startTimeMillis === endTimeMillis) {
       this.startEndTimeValidationStatus = false;
       this.uiService.showMessage('End time should be greater than Start time', AppSettings.MESSAGE_TYPES.ERROR);
    } else {
      this.startEndTimeValidationStatus = true;
    }
  }

  saveBulk() {

    const dataModel = this.getFormData();
      this.manageOpenShiftsService.addScheduleBulk(dataModel).subscribe(results => {
        this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
        this.router.navigate(['manage-shift/team-members/week']);
      }, (error) => {
        if (this.endDateTimeStr === -1) {
          this.endDateTimeStr = this.endDateTimeStr === -1 ? 'never' : this.endDateTimeStr;
        } else {
          this.endDateTimeS = this.endDateTimeStr;
          this.endDateTimeStr = 'custom';
        }
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
      });

  }

  onDelete() {
    const dataModel = this.getFormData();
    this.manageOpenShiftsService.deleteScheduleBulk(dataModel).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
      this.router.navigate(['manage-shift/team-members/week']);
    }, (error) => {
      if (this.endDateTimeStr === -1) {
        this.endDateTimeStr = this.endDateTimeStr === -1 ? 'never' : this.endDateTimeStr;
      } else {
        this.endDateTimeS = this.endDateTimeStr;
        this.endDateTimeStr = 'custom';
      }
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  onCancel() {
    if (this.ptoCheckbox) {
      this.showWithPtoDialog = false;
    } else {
      this.showWithoutPtoDialog = false;
    }
  }

  onShiftChange(event) {
   if (event.value === 'never') {
    this.endDateTimeSe = '';
   }
  }

  onDeleteMember() {
    this.setFormData();
   // this.validateForm();
    if (this.ptoCheckbox) {
      this.showWithPtoDialog = true;
    } else {
      this.showWithoutPtoDialog = true;
    }
  }

  onPtoSelected(event) {
    if (event) {
      this.ptoCheckbox = true;
    } else {
      this.ptoCheckbox = false;
    }

  }

  onBulkScheduleSave() {
   // this.selectedRowdata=selectedRowData;
    this.setFormData();
    this.validateForm();
    if (this.startEndTimeValidationStatus) {
      this.showDialog = true;
    }
  /*this.confirmationService.confirm({
    message: "Are you sure you want update existing schedule?",
      accept: () => {
        this.setFormData(selectedRowData);
        const dataModel = this.getFormData();
        this.manageOpenShiftsService.addScheduleBulk(dataModel).subscribe(results => {
          this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
          this.router.navigate(['manage-shift/shift-planning']);
        }, (error) => {
          if (this.endDateTimeStr === -1) {
            this.endDateTimeStr = this.endDateTimeStr === -1 ? 'never' : this.endDateTimeStr;
          } else {
            this.endDateTimeS = this.endDateTimeStr;
            this.endDateTimeStr = 'custom'
          }
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
        });
    }});*/
  }

  onStartDateClick(itemsData) {
    if (itemsData) {
      const formattedStartDate = moment(itemsData).format('MM/DD/YYYY') + ' 12:00 AM';
      this.maxDate = moment(formattedStartDate, 'MM/DD/YYYY hh:mm A').toDate();
    }
  }

  getTeam() {
    this.manageOpenShiftsService.getTeam(this.providerId).subscribe((result) => {
    const restrictedTeamsList = this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.TEAM_LVL);
      this.teamList.push({ label: this.commonBindingDataService.getLabel('Select'), value: '' });
      if (restrictedTeamsList?.length) {
        restrictedTeamsList.forEach(e => {
          result = result.filter(ele => ele.id !== e.teamId);
        });
      }
      for (let i = 0; i < result.length; i++) {
        this.teamList.push({ label: result[i].teamName, value: result[i].id });
      }
      if (this.assignedTeamId) {
        this.selectedTeamList = this.assignedTeamId;
      }
    }, () => {
    });
  }

  addShiftBtn() {
    this.isEditEnable = true;
    this.shiftButtonDisabled = true;
  }

  setFormData() {
    this.shiftButtonDisabled = false;
    const allocationList = '';
   /* for (let k = 0; k < this.weeklyAllocationData.length; k++) {
      if (selectedRowData[k].isMandatory === true) {
        allocationList += selectedRowData[k].key + ',';
      }
    }
    this.allocationListStr = allocationList.replace(/,\s*$/, ''); */
    if (!this.isDeleteCheckboxSelected) {
      if (this.startTimeStr.length > 8 || this.startTimeStr.length === undefined) {
        this.shiftStartTime = moment(this.startTimeStr).format('hh:mm A');
      } else {
        this.shiftStartTime = this.startTimeStr;
      }
      if (this.endTimeStr.length > 8 || this.endTimeStr.length === undefined) {
        this.shiftEndTime = moment(this.endTimeStr).format('hh:mm A');
      } else {
        this.shiftEndTime = this.endTimeStr;
      }
    }
    const startDate = new Date();
    this.startDateTimeStr = moment(this.endDateTimeS).format('MM/DD/YYYY') + ' ' + '12:00 AM';
    if (this.endDateTimeStr === 'custom') {
      this.endDateTimeStr = moment(this.endDateTimeSe).format('MM/DD/YYYY') + ' ' + '11:59 PM';
    } else {
      this.endDateTimeStr = -1;
    }
    if (this.endDateTimeStr === 'Never' || this.endDateTimeStr === -1) {
      this.endDateTimeStr = this.endDateTime = 'never';
      // this.endDateTimeS = ''
      // this.endDateTimeSe = ''

    } else {
      this.endDateTimeStr = this.endDateTime = 'custom';
      // this.endDateTimeS = this.endDateTimeS
      // this.endDateTimeSe = this.endDateTimeSe
    }
  }

  getFormData() {
    this.bulckScheduleId = [];
   // if (this.teamChecked) {
     // for (let k = 0; k < this.teamChecked.length; k++) {
        this.bulckScheduleId.push({
          'userId': this.userId
        });
      // }
    // }
    let requestFormModel;
    if (this.isDeleteCheckboxSelected) {
      requestFormModel = {
        'startTimeStr': '00:00 AM',
        'endTimeStr': '00:00 AM',
        'startDateTimeStr': this.startDateTimeStr,
        'endDateTimeStr':  this.endDateTimeStr === 'never' ? -1 : moment(this.endDateTimeSe).format('MM/DD/YYYY') + ' ' + '11:59 PM',
        'allocations': this.allocationListStr,
        'memberList': this.bulckScheduleId,
        'deletePtoSchedule': this.ptoCheckbox,
        'webShiftPlanUpdate': false,
        'shiftPlanId': '',
        'teamId': 0,
      };
    } else {
      requestFormModel = {
        'startTimeStr': this.shiftStartTime ? this.shiftStartTime
          : (this.startTimeStr.toString().includes('M') ? this.startTimeStr
            : moment(new Date(this.startTimeStr)).format('hh:mm A')),
        'endTimeStr': this.shiftEndTime ? this.shiftEndTime
          : (this.endTimeStr.toString().includes('M') ? this.endTimeStr
            : moment(new Date(this.endTimeStr)).format('hh:mm A')),
        'startDateTimeStr': this.startDateTimeStr,
        'endDateTimeStr':  this.endDateTimeStr === 'never' ? -1 : moment(this.endDateTimeSe).format('MM/DD/YYYY') + ' ' + '11:59 PM',
        'allocations': this.allocationListStr,
        'memberList': this.bulckScheduleId,
        'updateType': this.updateType,
        'webShiftPlanUpdate': false,
        'shiftPlanId': '',
        'teamId': this.userType === 'Mobile' ? this.selectedTeamList : 0,
      };
    }
    return requestFormModel;
  }


  getTime(date: any) {
    if (date !== '') {
      const hour = moment(date).format('hh:mm A').split(':');
      const time = this.commonBindingDataService.timeAdjustment(hour);
     // this.startTimeStr = moment(new Date(`1970-01-01 ${time}`)).format('hh:mm A')

    }

  }

  onDeleteSelected(event) {
    if (event === true) {
      this.isDeleteCheckboxSelected = true;
      this.startTimeStr = '';
      this.endTimeStr = '';
    } else {
      this.isDeleteCheckboxSelected = false;
      this.ptoCheckbox = false;
    }

  }
  getEndTime(date: any) {
    if (date !== '') {
      const hour1 = moment(date).format('hh:mm A');
      const hour = moment(date).format('hh:mm A').split(':');
      if (hour1 !== '11:59 PM') {
        const time = this.commonBindingDataService.timeAdjustment(hour);
        // this.endTimeStr = moment(new Date(`1970-01-01 ${time}`)).format('hh:mm A')
      }

    }
  }
  getLoginTypes(tagsData: any) {
    this.loginTypeList = [];
    this.loginTypeList.push({ label: this.commonService.getLabel('Select'), value: '' });
    tagsData.login_type.forEach(element => {
      this.loginTypeList.push({ label: element.tagValue, value: element.id });
    });
  }

  loginType(event) {
    this.loginTypeisWeb = event.value === '20' ? true : false;
  }

  cancelBut() {
    this.router.navigate(['manage-shift/team-members/week']);
  }

  allocationListData(event, index) {

      const allocationKey = (index + 1).toString();

      // Check if allocationKey is in allocationListStr
      if (this.allocationListStr?.includes(allocationKey)) {
        // Remove it if present
        const regex = new RegExp(`\\b${allocationKey}\\b,?`);
        this.allocationListStr = this.allocationListStr.replace(regex, '').replace(/,\s*$/, '');
      } else {
        // Add it if not present
        this.allocationListStr += this.allocationListStr ? `,${allocationKey}` : allocationKey;
      }

  }



  onHideDialog() {
    this.showDialog = false;
  }

  onHideWithoutPtoDialog() {
    this.showWithoutPtoDialog = false;
  }

  onHideWithPtoDialog() {
    this.showWithPtoDialog = false;
  }

  setAdjustValue() {
    this.updateType = 10;
    this.saveBulk();

  }

  setOverrideValue() {
    this.updateType = 20;
    this.saveBulk();
  }

}
